/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate, useParams } from "react-router-dom";
import { useProcess } from "@/global-data";
import { getUserInfo } from "@/lib/token";
import { wait } from "@/lib/wait";
import { apiServices } from "@/services/api.services";
import { useEffect, useMemo, useState } from "react";
import {
  companies,
  documentsDetails,
  documentsUpload,
  erpCustomerMapping,
  erpLog,
  // jobId,
  retailers,
  runDocument,
  runErpReprocess,
  workflow,
} from "@/services/global.services";
import {
  updateObject,
  getObject,
  findValueByKey,
  isKeyExist,
} from "@/lib/object-mutation";
// import { updateObject, getObject, isKeyExist } from "@/lib/object-mutation";
import { useToast } from "@/hooks/use-toast";
import { getFileUrl } from "@/lib/get-file-url";
import { getCurrentTimeZone, getJobId } from "@/lib/utils";
import { GenericType } from "@/types";
export const useDocumentDetails = () => {
  const timeZone = getCurrentTimeZone();

  const [allRetailerList, setAllRetailerList] = useState([]);
  const [reprocessDocId, setReprocessDocId] = useState(undefined);
  const [reprocessErpId, setReprocessErpId] = useState<any>(undefined);
  const [formPopupOpen, setFormPopupOpen] = useState(false);
  const [documentDeleteProcess, setDocumentDeleteProcess] = useState(false);
  const [documentVoidProcess, setDocumentVoidProcess] = useState(false);
  const [isVoid, setIsVoid] = useState(false);
  const [reprocessDocumentProcess, setReprocessDocumentProcess] =
    useState(false);
  const [isValid, setIsValid] = useState(false);

  const navigate = useNavigate();
  const { doc_id } = useParams();
  const { setProcess } = useProcess();
  const { toast } = useToast();

  const searchAddress = async ({
    value,
    endPoint,
  }: {
    value: string;
    endPoint: string;
  }) => {
    const payload = {
      data: {
        key: value,
        filter_by: {
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      endPoint,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data: data?.result?.metadata?.[erpCustomerMapping?.key], error };
  };

  const [workflowList, setWorkflowList] = useState<any>(undefined);
  const [currentCompanyData, setCurrentCompanyData] = useState<any>(undefined);

  const updateJsonData = async () => {
    setProcess(true);
    const payload = {
      data: {
        domain_json: state.detailsData?.domain_json,
        domain_id: state.detailsData.domain_id,
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      API_URL.feedback,
      "post",
      payload,
    );

    if (data) {
      const reloadResponse: any = await reloadPage();
      if (reloadResponse?.data) {
        toast({
          title: "Success",
          variant: "success",
          description:
            data?.result?.metadata?.message || "Record Updated Successfully",
        });
      }
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setProcess(false);
  };

  const updateAddress = async (prop: any) => {
    // setProcess(true);

    const getLocalKey = prop.key.replace("detailsData.", "");
    const updatedData = updateObject(
      state.detailsData,
      getLocalKey,
      prop.payload,
    );

    const payload = {
      data: {
        domain_json: updatedData.domain_json,
        domain_id: state.detailsData.domain_id,
      },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      API_URL.feedback,
      "post",
      payload,
    );

    if (data) {
      const reloadResponse: any = await reloadPage();
      if (reloadResponse?.data) {
        toast({
          title: "Success",
          variant: "success",
          description:
            data?.result?.metadata?.message || "Record Updated Successfully",
        });
      }
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    // setProcess(false);
  };

  const [originalDetailsData, setOriginalDetailsData] = useState(undefined);

  const [state, setGenericState] = useState<any>({
    domainError: undefined,
    documentError: undefined,
    skeltonLoading: true,
    erpLogPopup: false,
    erpLogData: [],
    detailsData: {},
    documentDetailsData: {},
    isEditMode: false,
    auditLogPopup: false,
    images: [],
    fileType: "",
    filePath: "",
    editingInput: [
      {
        name: "address",
        type: "select-update",
      },
    ],
  });

  const back = () => {
    navigate("/document");
  };

  const API_URL = useMemo(() => {
    return documentsDetails;
  }, [documentsDetails]);

  const { company_id, user_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id,
      user_id: tempUserData?.user_id || "",
    };
  }, []);

  useEffect(() => {
    (async () => {
      await reloadPage();
      // await loadingCompany();
      await loadingWorkflow();
      await loadingUsers();
      await loadingRetailer();
      await wait(1000);
      setState({
        type: "skelton",
        data: false,
      });
      setProcess(false);
    })();
  }, [doc_id]);

  const reloadPage = async () => {
    // domainError: undefined,
    // documentError: undefined,
    const documentResponse = await loadingList();
    if (documentResponse?.error) {
      setGenericState((prev: any) => ({
        ...prev,
        domainError: documentResponse?.error,
      }));
    }
    const domainResponse = await loadingDetailsData();
    if (domainResponse?.error) {
      setGenericState((prev: any) => ({
        ...prev,
        documentError: domainResponse?.error,
      }));
    }

    return {
      data: domainResponse?.data || documentResponse?.data,
      error: domainResponse?.error || documentResponse?.error,
    };
  };

  const onErpReprocess = async (formData: any): Promise<any> => {
    // setProcess(true);

    const payload = {
      data: {
        doc_id: formData.doc_id,
        domain_id: formData.domain_id,
      },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      runErpReprocess.post,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  // const getJobId = async (prop: string) => {
  //   const { data, error, message } = await apiServices<any>(
  //     jobId.get + prop,
  //     "get",
  //   );

  //   if (data?.process_status === "in-progress") {
  //     await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait 5 seconds before retrying
  //     const jobResponse: any = await getJobId(prop);
  //     return jobResponse;
  //   }
  //   if (data.error) {
  //     toast({
  //       title: "Error",
  //       variant: "destructive",
  //       description: error.status?.message || message,
  //     });
  //   }

  //   if (data?.status?.error_details?.fail_message) {
  //     toast({
  //       title: "Error",
  //       variant: "destructive",
  //       description: data?.status?.error_details?.fail_message,
  //     });
  //     return { data: null, error: data?.status?.error_details?.fail_message };
  //   }

  //   return { data, error };
  // };

  const loadingRetailer = async () => {
    const payload = {
      data: {
        filter_by: {
          search_text: "",
          exact_match: false,
          list_customer_name: true,
          pagination: {
            page_no: 1,
            no_of_recs: 1000,
            sort_by: "cts",
            order_by: true,
          },
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      retailers.get,
      "post",
      payload,
    );

    if (data) {
      setAllRetailerList(data.result.metadata?.[retailers.key]);
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const reprocessErp = async () => {
    // setProcess(true);
    setReprocessErpId("true");
    const erpReprocess = await onErpReprocess({
      doc_id: state?.detailsData?.doc_id,
      domain_id: state?.detailsData?.domain_id,
    });

    if (erpReprocess?.data) {
      if (erpReprocess?.data?.job_id) {
        const jobIdReprocess = await getJobId(erpReprocess?.data?.job_id);
        if (jobIdReprocess?.data) {
          // await loadingList();
          await reloadPage();
        }
      }
    } else {
      // await loadingList();
      await reloadPage();
    }
    setReprocessErpId(undefined);
  };

  const reprocessDocument = async (prop: any) => {
    setReprocessDocumentProcess(true);

    setReprocessDocId(prop.doc_id);
    const payload = {
      data: prop,
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      runDocument.post,
      "post",
      payload,
    );
    if (data?.job_id) {
      const jobIdReprocess = await getJobId(data.job_id);
      if (jobIdReprocess?.data) {
        await reloadPage();
      }
    }
    if (error) {
      await loadingList();
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }

    setReprocessDocumentProcess(false);

    setReprocessDocId(undefined);
  };

  const loadingList = async () => {
    const payload = {
      data: {
        doc_id: doc_id,
        filter_by: {
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      API_URL.get,
      "post",
      payload,
    );

    if (data) {
      const tempData = structuredClone(data.result.metadata[API_URL.key]);
      setOriginalDetailsData(tempData);
      // setGenericState((prev: any) => ({
      //   ...prev,
      //   originalDetailsData: data.result.metadata[API_URL.key],
      // }));
      setState({
        type: "data",
        data: data.result.metadata[API_URL.key],
      });
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const loadErpLogs = async () => {
    setProcess(true);
    const payload = {
      data: {
        doc_id: doc_id,
        filter_by: {
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      erpLog.get,
      "post",
      payload,
    );

    if (data) {
      setGenericState((prev: any) => ({
        ...prev,
        erpLogPopup: true,
        erpLogData: data.result.metadata["erp_logs"],
      }));
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setProcess(false);
    return { data, error };
  };

  const loadingDetailsData = async () => {
    const payload = {
      data: {
        filter_by: {
          doc_id: [doc_id],
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
      timezone: timeZone,
    };
    const { data, error, message } = await apiServices<any>(
      API_URL.document,
      "post",
      payload,
    );

    if (data) {
      const newData = data.result.metadata[API_URL.documentKey];
      const modulatedData = newData.find((item: any) => item.doc_id === doc_id);
      const fileType = modulatedData?.file_path?.split(".")?.at(-1);
      setGenericState((prev: any) => ({
        ...prev,
        fileType: fileType,
        filePath: modulatedData?.file_path,
      }));
      setState({
        type: "details-data",
        data: modulatedData,
      });
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const setState = ({ type, data }: { type: string; data: any }) => {
    switch (type) {
      case "data": {
        setGenericState((prev: any) => ({
          ...prev,
          detailsData: data,
          images: data?.images,
        }));

        break;
      }
      case "details-data": {
        setGenericState((prev: any) => ({
          ...prev,
          documentDetailsData: data,
        }));
        break;
      }
      case "update-data": {
        const getLocalKey = data.key.replace("detailsData.", "");
        const updatedData = updateObject(
          state.detailsData,
          getLocalKey,
          data.value,
        );

        setGenericState((prev: any) => ({
          ...prev,
          detailsData: updatedData,
        }));

        break;
      }
      case "skelton": {
        setGenericState((prev: any) => ({
          ...prev,
          skeltonLoading: data,
        }));
        break;
      }
      case "close-erp-log": {
        setGenericState((prev: any) => ({
          ...prev,
          erpLogData: [],
          erpLogPopup: false,
        }));
        break;
      }

      case "toggle-edit": {
        setGenericState((prev: any) => ({
          ...prev,
          isEditMode: !prev.isEditMode,
        }));
        break;
      }
      default: {
        // setGenericState(data);
        break;
      }
    }
  };

  const manageAuditLogPopup = (prop: boolean) => {
    setGenericState((prev: any) => ({
      ...prev,
      auditLogPopup: prop,
    }));
  };

  const loadingUsers = async () => {
    const payload = {
      data: {
        filter_by: {
          company_id: [company_id],
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      companies.get,
      "post",
      payload,
    );

    if (data) {
      setCurrentCompanyData(data.result.metadata[companies.key][0]);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };
  const loadingWorkflow = async () => {
    const payload = {
      data: {
        filter_by: {
          // ...retailerProp,
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      workflow.get,
      "post",
      payload,
    );

    if (data) {
      setWorkflowList(data.result.metadata?.[workflow.key]);
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const searchSupplier = async ({
    value,
    endPoint,
  }: {
    value: string;
    endPoint: string;
  }) => {
    const payload = {
      data: {
        key: value,
        filter_by: {
          search_text: "",
          exact_match: false,
        },
      },
      // company_id: company_id,
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message /* error, message, statusCode */ } =
      await apiServices<any>(endPoint, "post", payload);

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return {
      data: data?.result?.metadata?.["supplier_mapping"],
      error,
    };
  };

  const searchItemMaster = async ({
    value,
    endPoint,
  }: {
    value: string;
    endPoint: string;
  }) => {
    const payload = {
      data: {
        key: value,
        filter_by: {
          search_text: "",
          exact_match: false,
        },
      },
      // company_id: company_id,
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message /* error, message, statusCode */ } =
      await apiServices<any>(endPoint, "post", payload);

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    // return { data: data?.result?.metadata?.["erp_sku"], error };
    return {
      data: data?.result?.metadata?.["erp_sku"] || [],
      error,
    };
  };

  const updateSupplierMapping = async (prop: any) => {
    // setProcess(true);

    const getLocalKey = prop.key.replace("detailsData.", "");
    const updatedData = updateObject(
      state.detailsData,
      getLocalKey,
      prop.payload,
    );

    const payload = {
      data: {
        domain_json: updatedData.domain_json,
        domain_id: state.detailsData.domain_id,
      },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      API_URL.feedback,
      "post",
      payload,
    );

    if (data) {
      const reloadResponse: any = await reloadPage();
      if (reloadResponse?.data) {
        toast({
          title: "Success",
          variant: "success",
          description:
            data?.result?.metadata?.messages || "Record Updated Successfully",
        });
      }
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    // setProcess(false);
  };

  function replaceThirdLast(path: string, newValue: string) {
    const parts = path.split(".");

    if (parts.length < 3) return path; // safety

    const indexToReplace = parts.length - 3;
    parts[indexToReplace] = newValue;

    return parts.join(".");
  }

  const updateItemMaster = async (prop: any) => {
    const getLocalKey = prop.key.replace("detailsData.", "");
    const uomMasterPath = replaceThirdLast(getLocalKey, "uom_master");
    console.log({ getLocalKey, uomMasterPath });
    let updatedData = updateObject(
      state.detailsData,
      getLocalKey,
      prop.payload?.erp_sku_code,
    );

    if (prop.payload?.erp_uom && isKeyExist(updatedData, "uom_master")) {
      updatedData = updateObject(
        updatedData,
        uomMasterPath,
        prop.payload?.erp_uom,
      );
    }

    console.log({ updatedData, prop });
    setProcess(true);

    const payload = {
      data: {
        domain_json: updatedData.domain_json,
        domain_id: state.detailsData.domain_id,
      },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      API_URL.feedback,
      "post",
      payload,
    );

    if (data) {
      const reloadResponse: any = await reloadPage();
      if (reloadResponse?.data) {
        toast({
          title: "Success",
          variant: "success",
          description:
            data?.result?.metadata?.message || "Record Updated Successfully",
        });
      }
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setProcess(false);
  };

  const downloadDocument = async () => {
    const url = await getFileUrl(state.filePath);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    // the filename you want
    a.download = "todo-1.json";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  };

  function appendLastWithEmptyText(data: any) {
    const newData: any = structuredClone(data);
    const staticItem = {
      // regions: {},
      text: "",
      // row_number: 0,
      is_deleted: false,
    };

    // Find the max current length among array fields
    let maxLen = 0;
    for (const key in data) {
      if (Array.isArray(data[key])) {
        if (data[key].length > maxLen) maxLen = data[key].length;
      }
    }

    // After appending one item to arrays, this is the target length for all keys
    const targetLen = maxLen + 1 || 1;

    for (const key in newData) {
      const val = data[key];

      if (Array.isArray(val)) {
        // Append one static item
        const arr = [...val, { ...staticItem }];

        // Pad up to targetLen (handles cases where some arrays were shorter)
        while (arr.length < targetLen) {
          arr.push({ ...staticItem });
        }
        newData[key] = arr;
      } else {
        // Create a new array of targetLen filled with static items
        newData[key] = Array.from({ length: targetLen }, () => ({
          ...staticItem,
        }));
      }
    }

    return newData;
  }

  function markIndexDeletedInAllArrays(data: any, index: number) {
    const newData: any = structuredClone(data);

    for (const key in newData) {
      if (Array.isArray(newData[key])) {
        newData[key] = newData[key].flatMap((item: any, i: number) => {
          if (i === index) {
            if ("row_number" in item) {
              // Add or update is_deleted = true
              return [{ ...item, is_deleted: true }];
            } else {
              // Remove this item entirely
              return [];
            }
          }
          return [item];
        });
      }
    }

    return newData;
  }

  const mutationMasterData = ({ type, payload }: any) => {
    const getLocalKey = payload?.parentKey?.replace("detailsData.", "");
    const currentData = getObject(state.detailsData, getLocalKey);
    if (type === "add") {
      const temp1 = appendLastWithEmptyText(currentData);
      const updatedData = updateObject(state.detailsData, getLocalKey, temp1);
      setGenericState((prev: any) => ({
        ...prev,
        detailsData: updatedData,
      }));
    }

    if (type === "remove") {
      // const temp1 = removeIndexFromAllArrays(currentData, payload.index);
      const temp1 = markIndexDeletedInAllArrays(currentData, payload.index);
      const updatedData = updateObject(state.detailsData, getLocalKey, temp1);
      setGenericState((prev: any) => ({
        ...prev,
        detailsData: updatedData,
      }));
    }
  };

  const onRunDocument = async (prop: any): Promise<any> => {
    setProcess(true);

    const payload = {
      data: prop,
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      runDocument.post,
      "post",
      payload,
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  const uploadDocument = async (file_path: File) => {
    const payload = new FormData();

    payload.append("files", file_path);

    const { data, error, message } = await apiServices<any>(
      documentsUpload.post + "/" + company_id,
      "post",
      payload,
    );
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
      return { data, error, message };
    }

    return { data: data?.metadata?.file_path, error, message };
  };

  const formSubmitHandle = async (prop: any) => {
    setFormPopupOpen(false);
    if (!prop) return;
    setProcess(true);

    let results: any = null;
    let documentPayload = null;

    if (prop?.isMultiUpload) {
      const file_path_list: any = [];

      // results = await Promise.all(
      //   (prop?.file_path ?? []).map((filePath: any) => uploadDocument(filePath))
      // );
      results = await Promise.all(
        (prop?.file_path ?? []).map((filePath: any) =>
          uploadDocument(filePath.file),
        ),
      );
      results.forEach((element: any, index: number) => {
        if (element?.data) {
          file_path_list.push({
            file: element?.data,
            document_type: prop?.file_path?.[index]?.document_type,
          });
        }
      });
      // results.forEach((element: any) => {
      //   if (element?.data) {
      //     file_path_list.push({
      //       file: element?.data,
      //       document_type: prop?.document_type,
      //     });
      //   }
      // });
      documentPayload = {
        file_path: file_path_list,
        workflow_id: prop.workflow_id,
        doc_id: doc_id,
      };
      if (file_path_list?.length === 0) {
        setProcess(false);
      } else {
        const runDocument = await onRunDocument(documentPayload);
        await getJobId(runDocument.data.job_id);
        await loadingList();
      }

      if (results.error) {
        setProcess(false);
      }

      if (results.error) {
        toast({
          title: "Error",
          variant: "destructive",
          description: results?.error.status?.message || results?.message,
        });
      }
      setProcess(false);
    } else {
      results = await uploadDocument(prop?.file_path);
      documentPayload = {
        file_path: results.data,
        workflow_id: prop.workflow_id,
      };
      if (results?.data) {
        const runDocument = await onRunDocument(documentPayload);
        await getJobId(runDocument.data.job_id);
        await reloadPage();
        await loadingWorkflow();
        await loadingUsers();
      }

      if (results.error) {
        setProcess(false);
      }

      if (results.error) {
        toast({
          title: "Error",
          variant: "destructive",
          description: results?.error.status?.message || results?.message,
        });
      }
      setProcess(false);
      return results;
    }
  };

  const documentDelete = async (prop: boolean) => {
    setProcess(true);
    const payload = {
      data: {
        doc_id: doc_id,
        company_id: company_id,
        is_valid: prop,
      },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      API_URL.update,
      "post",
      payload,
    );

    if (data) {
      setIsValid(true);
      const reloadResponse: any = await reloadPage();
      if (reloadResponse?.data) {
        toast({
          title: "Success",
          variant: "success",
          description:
            data?.result?.metadata?.message || "Record Updated Successfully",
        });
      }
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setProcess(false);
  };

  useEffect(() => {
    setIsValid(state?.documentDetailsData?.is_valid);
  }, [state?.documentDetailsData?.is_valid]);

  const documentVoid = async (prop: boolean) => {
    setDocumentVoidProcess(true);
    const payload = {
      data: {
        doc_id: doc_id,
        company_id: company_id,
        is_void: prop,
      },
      company_id: company_id,
      user_id: user_id,
    };

    const { data, error, message } = await apiServices<any>(
      API_URL.update,
      "post",
      payload,
    );

    if (data) {
      setIsVoid(prop);
      const reloadResponse: any = await reloadPage();
      if (reloadResponse?.data) {
        toast({
          title: "Success",
          variant: "success",
          description:
            data?.result?.metadata?.message || "Record Updated Successfully",
        });
      }
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setDocumentVoidProcess(false);
  };

  useEffect(() => {
    setIsVoid(state?.documentDetailsData?.is_void ? true : false);
  }, [state?.documentDetailsData?.is_void]);

  const onUpdateIsSimilarityMatch = async (prop: any, prop2: any) => {
    const getLocalKey = prop?.replace("detailsData.", "");
    const currentData = getObject(state.detailsData, getLocalKey);
    currentData.text = prop2;
    const updatedData = updateObject(
      state.detailsData,
      getLocalKey,
      currentData,
    );

    console.log({ updatedData, currentData, prop, prop2 });

    setGenericState((prev: any) => ({
      ...prev,
      detailsData: updatedData,
    }));
  };

  const erp_price_validations =
    currentCompanyData?.settings?.erp_price_validations;
  const ignore_price_validations =
    currentCompanyData?.settings?.ignore_price_validations;
  const domain_json = state?.detailsData?.domain_json;
  const customer_mapping = findValueByKey(domain_json, "customer_mapping");
  const ignorePriceValidations = {
    erp_price_validations,
    ignore_price_validations,
    customer_mapping,
  };
  const onIgnorePriceValidations = async (prop: any) => {
    const payloadData = currentCompanyData;
    payloadData.settings = {
      ...currentCompanyData?.settings,
      ignore_price_validations: prop,
    };

    const payload = {
      data: payloadData,
      company_id: company_id,
      user_id: user_id,
    };

    console.log({ payload });

    setProcess(true);
    const { data } = await apiServices<GenericType>(
      companies.post,
      "post",
      payload,
    );

    if (data?.job_id) {
      const jobIdResponse = await getJobId(data.job_id);
      if (jobIdResponse.error) {
        return jobIdResponse;
      }
      await Promise.all([reloadPage(), loadingUsers()]);

      toast({
        title: "Success",
        variant: "success",
        description:
          jobIdResponse?.data?.result?.metadata?.message ??
          jobIdResponse?.data?.status?.msg ??
          jobIdResponse?.data?.status?.message,
      });
    }

    setProcess(false);
  };

  return {
    back,
    setState,
    state,
    searchAddress,
    updateAddress,
    updateJsonData,
    loadErpLogs,
    reprocessErp,
    reprocessDocument,
    currentCompanyData,
    workflowList,
    doc_id,
    user_id,
    company_id,
    manageAuditLogPopup,
    searchSupplier,
    updateSupplierMapping,
    reprocessErpId,
    reprocessDocId,
    domain_id: state.detailsData.domain_id,
    downloadDocument,
    searchItemMaster,
    updateItemMaster,
    mutationMasterData,
    formPopupOpen,
    setFormPopupOpen,
    formSubmitHandle,
    documentDelete,
    documentDeleteProcess,
    setDocumentDeleteProcess,
    isValid,
    setIsValid,
    documentVoid,
    documentVoidProcess,
    isVoid,
    onUpdateIsSimilarityMatch,
    originalDetailsData,
    allRetailerList,
    reprocessDocumentProcess,
    onIgnorePriceValidations,
    ignorePriceValidations,
  };
};
